import {useEffect} from 'react'
import PropTypes from 'prop-types';
import {clearFormValues, setFormValues} from 'redux/actions'
import {connect} from 'react-redux'
import useDebouncedEffect from "../hooks/useDebouncedEffect";


function SaveFormikValues({
	id,
	formikProps,
	setFormValues,
	clearFormValues,
	save=true,
	debounceTimeout = 500
}) {
	useEffect(()=> {
		return ()=> {
			clearFormValues(id);
		}
	},[id, clearFormValues])

	useDebouncedEffect(() => {
		if(save) {
			setFormValues(id, formikProps.values,  formikProps.dirty)
		}
	}, {timeout: debounceTimeout, ignoreInitialCall: false},[save, setFormValues, id, formikProps.values, formikProps.dirty])

	return null;
}

SaveFormikValues.propTypes = {
	classes: PropTypes.any,
	debounceTimeout: PropTypes.number
}

export default connect((state) => ({

}), {
	setFormValues,
	clearFormValues
})(SaveFormikValues);